var exports = {
  "container": "x43aef4ae--14102c--container",
  "icon-container": "x43aef4ae--14102c--icon-container",
  "icon": "x43aef4ae--14102c--icon",
  "icon--building": "x43aef4ae--14102c--icon--building",
  "icon--education": "x43aef4ae--14102c--icon--education",
  "icon--favorite": "x43aef4ae--14102c--icon--favorite",
  "title": "x43aef4ae--14102c--title",
  "description": "x43aef4ae--14102c--description",
};

module.exports = exports;
